import { replaceImageExtension } from '@utils'
import { API_URL } from '@constants'
import axiosReadInstance from '../../request/axiosReadInstance'
import { useEffect, useState } from 'react'
import { Image } from '@types'

interface Value {
    title: string
    description: string
    icon: {
        data: Image
    }
}

interface sharedValue {
    title: string
    values: Array<Value>
}

export const SharedValues = () => {
    const [sharedValues, setSharedValue] = useState<sharedValue>()

    const fetchData = async () => {
        await axiosReadInstance
            .get(`${API_URL}/api/shared-value?populate=deep`)
            .then((response) => {
                setSharedValue(response.data.data.attributes)
            })
    }

    useEffect(() => {
        fetchData()
    }, [])
    return (
        <section className="pt-24 px-6 sm:px-4">
            <div className="max-w-screen-xl mx-auto relative">
                <h2 className="h2 mb-10">{sharedValues?.title}</h2>
                <ul className={`mt-12 grid grid-cols-1 lg:grid-cols-3`}>
                    {sharedValues?.values.map((value, index) => {
                        return (
                            <li
                                key={index}
                                className={`flex flex-col gap-4 items-center text-center px-20 py-10 lg:border-l first:border-l-0 border-neutral-400`}
                            >
                                <img
                                    className="w-32"
                                    src={replaceImageExtension(
                                        value.icon.data.attributes.url
                                    )}
                                    alt={
                                        value.icon.data.attributes
                                            .alternativeText
                                    }
                                    aria-hidden="true"
                                />

                                <h3 className="h4">{value.title}</h3>

                                <p className="paragraph text-neutral-500">
                                    {value.description}
                                </p>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </section>
    )
}
